// extracted by mini-css-extract-plugin
module.exports = {"file":"Search_file__1Fzr6"};